module.exports = __webpack_public_path__ + "media/images/logo/mascf-ae3610e2bf3075d8d2df02a910e07031.svg";